import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { useMutation } from 'Data/Api.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'
import { useDataChange } from 'Simple/Data.js'

import mutation from './mutation.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let [, notify] = useNotifications()
  let [, executeMutation] = useMutation(mutation)
  let changeCharge = useDataChange({
    context: 'charge',
    viewPath: props.viewPath,
  })
  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onSubmit({ value, originalValue, args, change }) {
    if (!value.insurance_code_id) return true

    let mutationResponse = await executeMutation({
      id: value.id,
      object: {
        insurance_code_id: value.insurance_code_id,
        requires_tooth_details: value.requires_tooth_details,
      },
    })
    if (mutationResponse.error) {
      notify(notifyError(`An error has occurred while updating charge.`))
      return
    }

    let type =
      mutationResponse.data.update_vaxiom_misc_fee_charge_templates_by_pk

    changeCharge(next => {
      next.insurance_code_id = type.insurance_code_id
      next.requires_tooth_details = type.requires_tooth_details
    })

    notify(notifySuccess(`Charge has been updated.`))
    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
